import { render, staticRenderFns } from "./ModalPaidVerification.vue?vue&type=template&id=4534b11c&"
import script from "./ModalPaidVerification.vue?vue&type=script&lang=js&"
export * from "./ModalPaidVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports